var _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgServiceIcons(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 100,
    viewBox: "0 0 400 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#E6F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 35h40M30 50h40M30 65h40",
    stroke: "#0059b3",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 25l10 50M35 45l40-20",
    stroke: "#0059b3",
    strokeWidth: 2,
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#E6F3F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 20,
    stroke: "#0059b3",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 50l5 5 15-15",
    stroke: "#0059b3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#E6F3F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 65l10-20 10 10 20-30",
    stroke: "#0059b3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 4,
    fill: "#0059b3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 4,
    fill: "#0059b3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 25,
    r: 4,
    fill: "#0059b3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#E6F3F5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 15,
    stroke: "#0059b3",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 35v30M35 50h30",
    stroke: "#0059b3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 5,
    fill: "#0059b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcons);
export default __webpack_public_path__ + "static/media/service-icons.b0b32c2ebec75b4863e7c4924ed0aba0.svg";
export { ForwardRef as ReactComponent };